// Modelo Compañia para administrador.
export default class MonitoreoAudivoCs {
    fecha={}
    informacionLaboral=[
        {valor:"", descripcion:"", tipo:20 ,label:"a. Datos de filiación:", bold:false},
        {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
        {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
        {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
        {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
        {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
        {valor:"", descripcion:"", tipo:1 ,label:"b. Exposición al ruido en el trabajo:",data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"c. Si la respuesta es afirmativa, indicar el tiempo al día:",data:["< 2 horas","de 2 a 4 horas","> 4 horas","N/A"]},
        {valor:"", descripcion:"", tipo:1 ,label:"d. Exposición en días de la semana:" ,data:["< 2 días","de 2 a 4 días","todos los días","N/A"]},
        {valor:"", descripcion:"", tipo:1 ,label:"e. Uso de protectores auditivos:",data:["Nunca","A veces", "Siempre"]},
        {valor:"", descripcion:"", tipo:1 ,label:"f. En caso afirmativo:",data:["Tapones autorizados por el departamento de seguridad e higiene","Tapones NO autorizados por el departamento de seguridad e higiene", "Auriculares (conchas)  autorizados por el departamento de seguridad e higiene", "Auriculares (conchas)  NO autorizados por el departamento de seguridad e higiene", "Tapones y auriculares simultáneamente","N/A"]},
        {valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},
        {valor:"", descripcion:"", tipo:0 ,label:"Tipo Detalle",label2:"Tipo Detalle"},
        {valor:"", descripcion:"", tipo:4 ,label:"h. Exposiciones a ruido extra laboral:"},
        {valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},
        {valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Uso de moto:",data:["SI","NO"],label2:"veces/semana"},
        {valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Uso de armas de fuego:",data:["SI","NO"],label2:"veces/año"},
        {valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Uso de auriculares para escuchar música a alto volumen:",data:["SI","NO"],label2:"veces/semana"},
        {valor:"", descripcion:"", tipo:4 ,label:"i. Exposiciones a procesos peligrosos extra sonoros:"},
        {valor:"", descripcion:"", tipo:1 ,label:"i. Plomo" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"ii. Mercurio" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"iii. Monoxido de carbono" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"iv. Benceno" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"v. Otros (ver HCU):" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"vi. Medicamentos" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Aminoglucósidos (kanamicina, gentamicina, amikacina)" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Antituberculosos" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Salicilatos" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:0 ,label:"Otros (Ver HCU)"},
        {valor:"", descripcion:"", tipo:1 ,label:"vii. Posición forzada del cuello en el trabajo (flexión, extensión)" ,data:["SI","NO"]},

    ]
    antecedentesPersonales=[
        {valor:"", descripcion:"", tipo:1 ,label:"a. Pérdida de la audición" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"b. Otitis" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"c. Traumatismos del cráneo" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"d. Trastornos del cuello" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"e. Paperas" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"f. Sarampión" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"g. Salmonelosis" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"h. Infecciones de vías urinarias" ,data:["SI","NO"]},
    ]
    antecedentesPatologicos=[
        {valor:"", descripcion:"", tipo:1 ,label:"Hipertensión arterial" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Diabetes" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Otras metabólicas y degenerativas" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:3 ,label:"¿Cuales?"},
        {valor:"", descripcion:"", tipo:1 ,label:"Mentales" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:3 ,label:"¿Cuales?"},
    ]
    antecedentesFamiliaresCercanos=[
        {valor:"", descripcion:"", tipo:1 ,label:"a. Hipoacusia" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:3 ,label:"¿Quiénes?"},
        {valor:"", descripcion:"", tipo:1 ,label:"b. Trastornos del equilibrio" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:3 ,label:"¿Quiénes?"},
    ]
    sintomalogiaActual=[
        {valor:"", descripcion:"", tipo:1 ,label:"a. Siente que ha perdido la audición:" ,data:["SI","NO","NA"]},
        {valor:"", descripcion:"", tipo:3 ,label:"- Si la respuesta es positiva, especifique: -"},
        {valor:"", descripcion:"", tipo:3 ,label:"1. Desde cuándo en meses:"},
        {valor:"", descripcion:"", tipo:1 ,label:"2. Siente sordera en los dos oídos:" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"3. Aumenta el volumen de la radio o de la Tv:" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"4. Solicita que le hablen más alto o que repitan :" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"5. Le molesta los ruidos intensos:" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"b. Acúfenos:" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"c. Vértigo:" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"d. Otalgia:" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"e. Otorrea:" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"f. Otorragia:" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"g. Insomnio:" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"h. Irritabilidad (cambio del genio):" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"i. Trastornos digestivos frecuentes:" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"j. Cefalea:" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"k. Contracturas musculares (cuello, espalda, hombros):" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"l. Dolor del cuello frecuente:" ,data:["SI","NO"]},
    ]
    exploracion=[
        {valor:"", descripcion:"", tipo:1 ,label:"a. Pabellones auriculares:" ,data:["Normales","Atresia/Agenesia"]},
        {valor:"", descripcion:"", tipo:1 ,label:"b. Conducto auditivo externo:" ,data:["Permeable","Tapón de cerumen o epidermoideo","Secreciones muco-purulentas"]},
        {valor:"", descripcion:"", tipo:4 ,label:"c. Membrana timpánica:" ,data:["Normales","Atresia/Agenesia"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Normal" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Perforada" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Hiperémica" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Abombada" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Retraída" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Con placas blanquecinas" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"CONCLUSIÓN" ,data:["NORMAL","ANORMAL"]},
        {valor:"", descripcion:"", tipo:1 ,label:"d. Prueba de Rinne oído derecho:" ,data:["POSITIVO","NEGATIVO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"e. Prueba de Rinne oído izquierdo:" ,data:["POSITIVO","NEGATIVO"]},
        {valor:"", descripcion:"", tipo:1 ,label:"f. Prueba de Weber:" ,data:["Lateraliza a la derecha","Lateraliza a la izquierda","No lateraliza"]},
        {valor:"", descripcion:"", tipo:1 ,label:"g. Puntos dolorosos en cuello y región dorsal:" ,data:["SI","NO"]},
    ]
    hizoAudiometria=[
        {valor:"", descripcion:"", tipo:1 ,label:"Se realizó audiometría" ,data:["SI","NO","NA"]},
        {valor:"", descripcion:"", tipo:3 ,label:"Si la respuesta es positiva, registre el resultado"},

    ]
    disponeSometria=[
        {valor:"", descripcion:"", tipo:1 ,label:"Sonometría" ,data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:3 ,label:"Valor:"},
        {valor:"", descripcion:"", tipo:1 ,label:"Dosimetría:",data:["SI","NO"]},
        {valor:"", descripcion:"", tipo:3 ,label:"Valor:"},
    ]
    capacitaciones=[
        {valor:"", descripcion:"", tipo:1 ,label:"Características de ruido" ,data:["Frecuentemente","Rara vez", "Nunca"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Efectos en la salud por el ruido" ,data:["Frecuentemente","Rara vez", "Nunca"]},
        {valor:"", descripcion:"", tipo:1 ,label:"Medidas de protección y prevención contra el ruido" ,data:["Frecuentemente","Rara vez", "Nunca"]},
    ]
    conclusiones=[
        {valor:"", descripcion:"", tipo:5 ,label:"" },
    ]
    recomendaciones=[
        {valor:"", descripcion:"", tipo:5 ,label:"" },
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoAudivoCs.js